//Common Styles
import {
  HorizontalLine,
  InlineSpaceBetweenContainer,
  Paragraph,
  SectionHeader,
  SectionTitle,
  ShowLabel,
  ShowValue,
  WorkspacePanel,
  WorkspaceSection,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

//Icons
import { RecieptIcon } from "../Svg";

//Colors
import { colors } from "../../styles/colors";

const ChefForPartyPaymentSummary = ({ record }: { record: any }) => {
  return (
    <WorkspacePanel>
      <WorkspaceSection>
        <SectionHeader>
          <WorkSpaceTitleRow>
            <RecieptIcon color={colors.primary} height={20} width={20} />
            <SectionTitle>Payment Summary</SectionTitle>
          </WorkSpaceTitleRow>
        </SectionHeader>
      </WorkspaceSection>

      <InlineSpaceBetweenContainer>
        <ShowLabel>Total Amount</ShowLabel>
        <ShowValue>{record?.totalAmount || "-"}</ShowValue>
      </InlineSpaceBetweenContainer>
      <InlineSpaceBetweenContainer>
        <ShowLabel>Discount</ShowLabel>
        <ShowValue>{record?.totalDiscount || "-"}</ShowValue>
      </InlineSpaceBetweenContainer>
      <HorizontalLine style={{ margin: "8px 0" }} />
      <InlineSpaceBetweenContainer>
        <ShowLabel>Net Party Amount</ShowLabel>
        <ShowValue>
          {(
            Number(record?.totalAmount) - Number(record?.totalDiscount)
          ).toFixed(2)}
        </ShowValue>
      </InlineSpaceBetweenContainer>
      <InlineSpaceBetweenContainer>
        <ShowLabel>Token</ShowLabel>
        <ShowValue>{record?.tokenAmount || "-"}</ShowValue>
      </InlineSpaceBetweenContainer>
      <InlineSpaceBetweenContainer>
        <ShowLabel>Amount Paid</ShowLabel>
        <ShowValue>{record?.amountPaid || "-"}</ShowValue>
      </InlineSpaceBetweenContainer>
      <InlineSpaceBetweenContainer>
        <ShowLabel>Cashback Amount</ShowLabel>
        <ShowValue>
          {record?.cashback?.amount != null ? `₹${record.cashback.amount}` : "-"}
        </ShowValue>
      </InlineSpaceBetweenContainer>
      <InlineSpaceBetweenContainer>
        <ShowLabel>Partial Payment</ShowLabel>
        <ShowValue>
          {record?.partialPayment
            ? `${record?.partialPayment} (${record?.partialPaymentStatus})`
            : "-"}
        </ShowValue>
      </InlineSpaceBetweenContainer>

      {record?.isCashCollected === true && (
        <InlineSpaceBetweenContainer>
          <ShowLabel>Cash Collected</ShowLabel>
          <ShowValue>
            {record?.amount_to_be_collected != null ? `₹${record.amount_to_be_collected}` : "-"}
          </ShowValue>
        </InlineSpaceBetweenContainer>
      )}

      <HorizontalLine style={{ margin: "8px 0" }} />

      <InlineSpaceBetweenContainer
        style={{
          backgroundColor: "rgba(25, 117, 210, 0.05)",
          padding: "8px",
          borderRadius: "8px",
        }}
      >
        <Paragraph>Net Payable</Paragraph>
        <ShowValue>{record?.netPayableAmount || "-"}</ShowValue>
      </InlineSpaceBetweenContainer>
    </WorkspacePanel>
  );
};

export default ChefForPartyPaymentSummary;
